import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=1597d15f&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=ts&"
export * from "./Department.vue?vue&type=script&lang=ts&"
import style0 from "./Department.vue?vue&type=style&index=0&id=1597d15f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597d15f",
  null
  
)

export default component.exports